import { useState } from "react";
import { Col, Row } from "antd";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/nl";

import { AgentDossierSessionsCard } from "../components/AgentDossierSessionsCard";
import { DossierAgentSessions } from "../../../../lib/api/resources/agent";
import { AgentDossierMessagesCard } from "../components/AgentDossierMessagesCard";
import { AgentSession } from "@rumble-it/common-lib/types/models/AgentSession.interface";

dayjs.extend(relativeTime);
dayjs.locale("nl");

export const AgentDossierChatSessionsTab = ({
  data,
  isLoading,
}: {
  data?: DossierAgentSessions;
  isLoading: boolean;
}) => {
  const [selectedSession, setSelectedSession] = useState<AgentSession | null>(
    null,
  );

  return (
    <Row gutter={[16, 16]} style={{ height: "calc(100vh - 200px)" }}>
      <Col xxl={{ span: 8 }} span={24} style={{ height: "100%" }}>
        <AgentDossierSessionsCard
          isLoading={isLoading}
          sessions={data?.agentSessions || []}
          selectedSession={selectedSession}
          setSelectedSession={setSelectedSession}
        />
      </Col>
      <Col xxl={{ span: 16 }} span={24} style={{ height: "100%" }}>
        <AgentDossierMessagesCard selectedSession={selectedSession} />
      </Col>
    </Row>
  );
};
